export default __webpack_public_path__ + "static/media/allgemein_39.aeb0b72a.jpg";